"use client";

import { useSyncExternalStore } from "react";

function subscribe(onChange: () => void) {
	window.addEventListener("languagechange", onChange);
	return () => window.removeEventListener("languagechange", onChange);
}

export function usePreferredBrowserLanguage(): string | null {
	return useSyncExternalStore(
		subscribe,
		() => navigator.languages?.[0] ?? navigator.language,
		() => null,
	);
}
